import {Stack, TextField, TextFieldProps, Typography, styled} from '@mui/material';
import {forwardRef} from 'react';

const Label = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 14,
  color: '#374151',
}));

const Field = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    backgroundColor: '#FFFFFF',
  },

  '& .MuiInputBase-input': {
    height: 41,
    padding: '0 12px',
    fontWeight: 400,
    fontSize: 16,
  },
}));

type SimpleFieldProps = Omit<TextFieldProps<'outlined'>, 'variant' | 'size' | 'sx' | 'inputRef'>;

export const SimpleField = forwardRef<HTMLInputElement, SimpleFieldProps>(({label, ...props}, ref) => {
  return (
    <Stack gap="4px" width="100%">
      <Label>{label}</Label>
      <Field inputRef={ref} {...props} />
    </Stack>
  );
});

SimpleField.displayName = 'SimpleField';
